import z from 'zod';

export const CURRENT_VERSION = 'v008' as const;
export const Version = z.literal(CURRENT_VERSION);
export type Version = z.infer<typeof Version>;

export const ElementId = z.string(); // We should use z.uuid() as soon as possible
export const UnityElementId = ElementId.optional();

export const EmptyChildren = z.tuple([z.strictObject({ text: z.literal('') })]);
export type EmptyChildren = z.infer<typeof EmptyChildren>;
export const emptyChildren: EmptyChildren = [{ text: '' }];

/** Unity (backend) text attributes - uses `underlined` and `commentId` */
export const UnityTextAttributes = z.object({
    bold: z.boolean().optional(),
    italic: z.boolean().optional(),
    underlined: z.boolean().optional(),
    code: z.boolean().optional(),
    subscript: z.boolean().optional(),
    superscript: z.boolean().optional(),
    commentId: z.string().optional(),
});
export type UnityTextAttributes = z.infer<typeof UnityTextAttributes>;

/** Plate text attributes - uses `underline` and dynamic `comment_<id>` keys */
export const PlateTextAttributes = z.object({
    bold: z.boolean().optional(),
    italic: z.boolean().optional(),
    underline: z.boolean().optional(),
    code: z.boolean().optional(),
    subscript: z.boolean().optional(),
    superscript: z.boolean().optional(),
    comment: z.boolean().optional(),
});

// Type includes dynamic comment_<id> keys that the schema can't express
export type PlateTextAttributes = z.infer<typeof PlateTextAttributes> &
    Record<`comment_${string}`, true | undefined>;
